<template>
  <v-tooltip bottom :disabled="!tooltip">
    <template #activator="{ on }">
      <div class="upload-breakdown-item" v-on="on">
        <div
          class="upload-breakdown-item__accent"
          :class="color"
        ></div>
        <div class="upload-breakdown-item__icon" :class="color">
          <v-icon size="18" :color="iconColor">{{ icon }}</v-icon>
        </div>
        <div class="upload-breakdown-item__content">
          <div class="upload-breakdown-item__value">
            {{ formattedValue }}
          </div>
          <div class="upload-breakdown-item__label">{{ label }}</div>
        </div>
      </div>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'UploadBreakdownItem',
  props: {
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
    iconColor: {
      type: String,
      default: 'white',
    },
    value: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  computed: {
    formattedValue() {
      return this.value.toLocaleString();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.upload-breakdown-item {
  display: flex;
  align-items: center;
  padding: 12px;
  background: white;
  border-radius: 8px;
  border: 1px solid map-get($grey, 'lighten-3');
  cursor: default;
  position: relative;
  overflow: hidden;

  // Colour-matched accent bar; inherits the tile's Vuetify colour class so it
  // reflects the data point's colour (indigo/blue/teal/…) rather than default text.
  &__accent {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover &__accent {
    opacity: 0.9;
  }

  &__icon {
    width: 36px;
    height: 36px;
    min-width: 36px;
    min-height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &__content {
    flex: 1;
    min-width: 0;
  }

  &__value {
    font-size: 20px;
    font-weight: 600;
    color: map-get($grey, 'darken-4');
    line-height: 1.2;
  }

  &__label {
    font-size: 12px;
    color: map-get($grey, 'darken-1');
    margin-top: 2px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 500;
  }
}
</style>
